var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"id":"supheader","dense":"","flat":""},scopedSlots:_vm._u([{key:"extension",fn:function(){return [_c('SupplierTabs')]},proxy:true}])},[_c('v-toolbar-title',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs,"divider":">"}})],1),_c('div',{staticClass:"flex-grow-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }